import Image from 'next/image';
import { IoIosArrowBack } from 'react-icons/io';
import { avatars } from '../SelectPfp';
export default function AvailableAvatars({
  toggleModal,
  handleSelect,
  selected
}) {
  return <div className='pt-4 px-4 ta-l overflow-y-auto' data-sentry-component="AvailableAvatars" data-sentry-source-file="AvailableAvatars.tsx">
      <div onClick={() => toggleModal()} className='cursor-pointer text-[14px] flex items-center bg-genius-blue rounded-full h-[31px] w-[74px]'>
        <IoIosArrowBack className={`ml-2 mr-2 w-[16px] text-genius-cream`} width={20} height={18} data-sentry-element="IoIosArrowBack" data-sentry-source-file="AvailableAvatars.tsx" />{' '}
        <p>Back</p>
      </div>
      <p className='text-[14px] text-genius-cream my-4'>Choose a Profile Picture</p>
      <p className='text-[12px] text-genius-cream/50'>
        Reserve your Genius for $BRAINIAC mint season!
      </p>
      <div className='w-full justify-center ta-c m-auto grid grid-cols-3 gap-4 mt-4'>
        {avatars.map((avatar, index) => <div key={avatar.file} className='relative'>
            <Image src={`/genie/${avatar.file}`} width={200} height={200} alt={`Avatar ${index + 1}`} className={`cursor-pointer w-[130px] h-[130px] rounded-lg`} onClick={() => handleSelect(avatar)} />
            {selected && selected.file === avatar.file ? <div className='absolute top-2 right-2 bg-genius-blue rounded-full p-2 border-[1px] border-white'>
                {/* Dot indicating selection */}
              </div> : <div className='absolute top-2 right-2 bg-genius-pink rounded-full p-2'>
                {/* Dot indicating selection */}
              </div>}
            <div className='absolute top-2 left-2 text-white text-[14px] bg-gray-900 bg-opacity-75 px-3 py-[1px] rounded-full'>
              {avatar.name}
            </div>
          </div>)}
      </div>
    </div>;
}